'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * isRequiredIf allows a PropType to be optionally required based on a condition function. This
 * condition function will receive the props and should return a boolean. A truthy value will
 * cause the type to be required. This is a way to say, for example, if the component has
 * loading === false, require the data prop _and_ if loading === true don't require the data prop.
 * @param {function} type the PropType to be validated, ex. PropTypes.string
 * @param {function} condition a function that recieves the props and returns a boolean.
 * @returns {function} the PropType, with `.isRequired` if needed.
 */
function isRequiredIf(type, condition) {
  return function (props) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var test = condition(props) ? type.isRequired : type;
    return test.apply(undefined, [props].concat(rest));
  };
}

var menuSubItem = _propTypes2.default.shape({
  message: _propTypes2.default.string.isRequired,
  path: _propTypes2.default.string,
  url: _propTypes2.default.string
});

var menuSubItems = _propTypes2.default.arrayOf(menuSubItem);

var menuItem = _propTypes2.default.shape({
  icon: isRequiredIf(_propTypes2.default.string, function (props) {
    return !props.loading;
  }),
  loading: _propTypes2.default.bool,
  menuSubItems: isRequiredIf(menuSubItems, function (props) {
    return !!(!props.loading && !props.path && !props.url);
  }),
  message: isRequiredIf(_propTypes2.default.string, function (props) {
    return !props.loading;
  }),
  path: _propTypes2.default.string,
  url: _propTypes2.default.string
});

var menuGroup = _propTypes2.default.arrayOf(menuItem);

var menuGroups = _propTypes2.default.arrayOf(menuGroup);

exports.default = {
  menuSubItem: menuSubItem,
  menuSubItems: menuSubItems,
  menuItem: menuItem,
  menuGroup: menuGroup,
  menuGroups: menuGroups
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/menuPropTypes.js
// module id = 112
// module chunks = 2